// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1869":"styles","3840":"vendors~cdd60c62~49d0a293","4001":"vendors~cdd60c62~0e038a73"}[chunkId] + ".css";
};